/* eslint-disable max-len */
// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.quoteDetails = (await import('./pages/QuoteDetails/QuoteDetailsWrapper.tsx')).QuoteDetailsWrapper;
    Components.home = (await import('./pages/Dashboard/DashboardWrapper.tsx')).DashboardWrapper;
    Components.default = (await import('./pages/Home.tsx')).Home;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  quoteDetails: {
    name: 'QuoteDetailsWrapper',
    componentName: 'QuoteDetailsWrapper',
    chunk: () => import('./pages/QuoteDetails/QuoteDetailsWrapper.tsx'),
    get component() {
      return ssr
        ? serverPages.quoteDetails
        : currentRouteName === 'QuoteDetailsWrapper'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({
            default: pageModule.QuoteDetailsWrapper,
          })));
    },
    path: '/:context?/quote/details/:quoteId/customer/:customerId/user/:userId',
    channel: null,
  },

  home: {
    name: 'DashboardWrapper',
    componentName: 'DashboardWrapper',
    chunk: () => import('./pages/Dashboard/DashboardWrapper.tsx'),
    get component() {
      return ssr
        ? serverPages.home
        : currentRouteName === 'DashboardWrapper'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({
            default: pageModule.DashboardWrapper,
          })));
    },
    path: '/:context?/quote/list',
    channel: null,
  },

  // This is the default path, currently setting to list page
  default: {
    name: 'Home',
    componentName: 'Home',
    chunk: () => import('./pages/Home.tsx'),
    get component() {
      return ssr
        ? serverPages.default
        : currentRouteName === 'Home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({
            default: pageModule.Home,
          })));
    },
    path: '/:context?/',
    channel: null,
  },
});
